import { useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { BRAND } from './config/brand'
import { useAuthStore } from './store/auth'
import { AuditPage } from './pages/AuditPage'
import { DashboardPage } from './pages/DashboardPage'
import { EmployeesPage } from './pages/EmployeesPage'
import { GroupsPage, PublicMailboxesPage } from './pages/MailboxesPage'
import { LoginPage } from './pages/LoginPage'

export default function App() {
  const user = useAuthStore((state) => state.user)
  const ready = useAuthStore((state) => state.ready)
  const check = useAuthStore((state) => state.check)
  const expire = useAuthStore((state) => state.expire)

  useEffect(() => {
    void check()
    const onExpired = () => expire()
    window.addEventListener('bluewhale:auth-expired', onExpired)
    return () => window.removeEventListener('bluewhale:auth-expired', onExpired)
  }, [check, expire])

  if (!ready) {
    return <div className="app-loading"><span className="loader" /><strong>{BRAND.productName}</strong><small>正在载入管理中心</small></div>
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={user ? <AppShell /> : <Navigate to="/login" replace />}>
          <Route index element={<DashboardPage />} />
          <Route path="employees" element={<EmployeesPage />} />
          <Route path="groups" element={<GroupsPage />} />
          <Route path="public-mailboxes" element={<PublicMailboxesPage />} />
          <Route path="audit" element={<AuditPage />} />
        </Route>
        <Route path="*" element={<Navigate to={user ? '/' : '/login'} replace />} />
      </Routes>
    </BrowserRouter>
  )
}
